import Phaser from 'phaser';
import Player, { preload as preloadPlayer } from '../../objects/test/Player';

export default class PlayerObject extends Phaser.Scene {
  constructor() {
    super({ key: 'PlayerObject', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadPlayer.call(this);
    this.load.image(`spell`, `CharacterVectors/Spells Effect.png`);
  }

  create() {
    this.physics.world.setBoundsCollision(true);
    
    this.player = new Player({
      scene: this,
      x: this.game.config.width / 2,
      y: this.game.config.height / 2,
    });

    this.spells = this.add.particles('spell');

    this.spellsEmitter = this.spells.createEmitter({
      x: this.player.x + 100,
      y: this.player.y,
      speed: { min: 400, max: 600 },
      angle: { min: 0, max: 45 },
      // gravityY: 200,
      scale: { start: 1, end: 0.2, random: true },
      quantity: 5,
      frequency: 100,
      // blendMode: 'ADD', // 'SCREEN'
      // bounce: 0.9,
      // collideTop: false,
      // collideBottom: false,
      lifespan: 2000,
      on: false,
    });

    this.cameras.main.shake(2000, 0.005);

    this.player.setInteractive();

    this.input.on('pointerdown', () => {
      // this.spellsEmitter.emitParticleAt(this.player.x, this.player.y);
      this.spellsEmitter.explode();
    });
  }
}
